<template>
  <v-col sm="12 pt-0">
    <template>
      <v-simple-table fixed-header class="table-taxonomy nav-table">
        <template v-slot:default>
          <VuePerfectScrollbar
            class="drawer-menu--scroll"
            :settings="scrollSettings"
          >
            <thead>
              <tr class="primary">
                <th class="f-14 white--text text-center">
                  Date
                </th>
                <th
                  :width="budgetMovement.length > 0 ? '' : '9%'"
                  class="f-14 white--text text-center"
                >
                  Updated By
                </th>
                <th
                  :width="budgetMovement.length > 0 ? '' : '10.5%'"
                  class="f-14 white--text text-center"
                >
                  Budget Code
                </th>
                <th
                  :width="budgetMovement.length > 0 ? '' : '10.5%'"
                  class="f-14 white--text text-center"
                >
                  Taxonomy Code
                </th>
                <th
                  :width="budgetMovement.length > 0 ? '100%' : '14.5%'"
                  class="f-14 white--text text-center"
                >
                  Taxonomy Description
                </th>
                <th
                  :width="budgetMovement.length > 0 ? '' : '10%'"
                  class="f-14 white--text text-center"
                >
                  Sign Off Budget
                </th>
                <th
                  :width="budgetMovement.length > 0 ? '' : '10%'"
                  class="f-14 white--text text-center"
                >
                  Initial Budget
                </th>
                <th
                  :width="budgetMovement.length > 0 ? '' : '13%'"
                  class="f-14 white--text text-center"
                >
                  Reallocation Budget
                </th>
                <th
                  :width="budgetMovement.length > 0 ? '' : '10%'"
                  class="f-14 white--text text-center"
                >
                  Final Budget
                </th>
                <th
                  :width="budgetMovement.length > 0 ? '' : '12%'"
                  class="f-14 white--text text-center"
                >
                  Transaction Type
                </th>
                <th class="f-14 white--text text-center">
                  Reason
                </th>
              </tr>
            </thead>
            <tbody v-if="budgetMovement.length > 0">
              <!-- <tr>
								<td class="text-center" colspan="2">
									<label>COMING SOON</label>
								</td>
							</tr> -->
              <tr v-for="(history, index) in budgetMovement" :key="index">
                <td class="fs-12">
                  {{ formatDateTime(history.date) || '-' }}
                </td>
                <td class="fs-12">
                  {{ history.email || '-' }}
                </td>
                <td class="fs-12">
                  {{ history.budget_code || '-' }}
                </td>
                <td class="fs-12">
                  {{ history.taxo_code || '-' }}
                </td>
                <td class="fs-12">{{ history.desc || '-' }}</td>
                <td class="text-right fs-12">
                  {{ history.sign_off ? idr(history.sign_off) || '-' : '-' }}
                </td>
                <td class="text-right fs-12">
                  {{ idr(history.amount_before) || '-' }}
                </td>
                <td class="text-right fs-12">
                  {{ idr(history.transfered_amount) || '-' }}
                </td>
                <td class="text-right fs-12">
                  {{ idr(history.final_amount) || '-' }}
                </td>
                <td class="text-capitalize fs-13 font-weight-500">
                  {{
                    history.type
                      ? String(history.type)
                          .split('_')
                          .join(' ')
                          .toLowerCase()
                      : '-'
                  }}
                </td>
                <td class="fs-12">
                  {{ history.reason || '-' }}
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="11" class="text-center fs-12">
                  No data displayed
                </td>
              </tr>
            </tbody>
          </VuePerfectScrollbar>
        </template>
      </v-simple-table>
      <!-- <v-simple-table
				:loading="loading"
				class="spending-table"
			>
				<template v-slot:default>
					<thead>
						<tr
							class="grey lighten-2"
							style="white-space: nowrap"
						>
							<td
								class="f-14 font-weight-bold textblack--text"
								colspan="2"
							>
								Total
							</td>
							<td
								class="f-14 font-weight-bold textblack--text text-right"
							>
								{{ '0' }}
							</td>
							<td
								class="f-14 font-weight-bold textblack--text text-right"
							>
								0
							</td>
							<td
								class="f-14 font-weight-bold textblack--text text-right"
							>
								0%
							</td>
							<td
								class="f-14 font-weight-bold textblack--text text-right"
							>
								0%
							</td>
							<td
								class="f-14 font-weight-bold textblack--text text-right"
							>
								0%
							</td>
						</tr>
					</thead>
				</template>
			</v-simple-table> -->
    </template>
  </v-col>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  components: {
    VuePerfectScrollbar
  },
  props: {
    budgetMovement: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      scrollSettings: {
        maxScrollbarLength: 260
      }
    };
  }
};
</script>
